var _path, _path2, _path3, _path4, _path5, _path6, _path7;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNotSure(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 462,
    height: 442,
    viewBox: "0 0 462 442",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M220.801 441.602C99.0505 441.602 0 342.551 0 220.801C0 99.0505 99.0505 0 220.801 0C342.551 0 441.602 99.0505 441.602 220.801C441.602 342.551 342.551 441.602 220.801 441.602ZM220.801 55.6641C129.744 55.6641 55.6641 129.744 55.6641 220.801C55.6641 311.858 129.744 385.938 220.801 385.938C311.858 385.938 385.938 311.858 385.938 220.801C385.938 129.744 311.858 55.6641 220.801 55.6641Z",
    fill: "#00607F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M220.801 0V55.6641C311.858 55.6641 385.938 129.744 385.938 220.801C385.938 311.858 311.858 385.938 220.801 385.938V441.602C342.551 441.602 441.602 342.551 441.602 220.801C441.602 99.0505 342.551 0 220.801 0Z",
    fill: "#002C3C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M221 284.453L206 312.227L221 340C237.569 340 251 327.565 251 312.227C251 296.888 237.569 284.453 221 284.453Z",
    fill: "#0A77E8"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M191 312.227C191 327.565 204.431 340 221 340V284.453C204.431 284.453 191 296.888 191 312.227Z",
    fill: "#0F9AF0"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M221 103L191 130.773L221 158.547C230.925 158.547 239 166.022 239 175.211C239 180.107 236.679 184.742 232.63 187.927L221 197.081L201 233.824L221 270.566H251V246.377L271.488 230.251C288.972 216.497 299 196.436 299 175.211C299 135.394 264.009 103 221 103V103Z",
    fill: "#0A77E8"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M191 220.694V270.567H221V197.081L191 220.694Z",
    fill: "#0F9AF0"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M143 175.211V182.154H203V175.211C203 166.022 211.075 158.547 221 158.547V103C177.991 103 143 135.394 143 175.211Z",
    fill: "#0F9AF0"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotSure);
export default __webpack_public_path__ + "static/media/not-sure.3d5dc3033c8149a0102374610601849a.svg";
export { ForwardRef as ReactComponent };